import React from "react";
import {
  Typography,
  Divider,
  Avatar,
  Box,
} from "@mui/material";

const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#073060ff", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#61b8ffff", "#FFFFFF"],
  DET: ["#0C2C56", "#f62e23ff", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#143680ff", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CD6", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#be8e14ff", "#FFFFFF"],
  STL: ["#BE0A15", "#b6b31bff", "#FFFFFF"],
  LAD: ["#005A9D", "#005184ff", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#000000ff", "#FFFFFF"],
  GDD: ["#F15C22", "#000000", "#FFFFFF"],
  MSS: ["#F4D12F", "#C80F2D", "#FFFFFF"],
  PEJ: ["#807E82", "#C1D72E", "#FFFFFF"],
  SRR: ["#008B98", "#B49A64", "#FFFFFF"],
  SCO: ["#C80F2D", "#000000ff", "#FFFFFF"],
  SUR: ["#49A942", "#BA0E2A", "#FFFFFF"],
  "0": ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};

export default function Article11(props: any) {

  return (
    <div>
      <title>Prospect Savant goes to the Arizona Fall League - Who I'm Watching</title>
      <Typography
        variant="h4"
        component="h1"
        style={{
          fontWeight: "bold",
          color: "#000000",
          textAlign: "center",
          fontSize: props.isDesktop ? "32pt" : "20pt",
        }}
      >
        Prospect Savant goes to the Arizona Fall League - Who I'm Watching
      </Typography>
      <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          marginBottom: "12px",
          color: "rgba(0, 0, 0, 0.7)",
          textAlign: "center",
          fontSize: props.isDesktop ? "18pt" : "14pt",
        }}
      >
        By Duke Hill • November 5th, 2025
      </Typography>
      <Divider variant="middle" style={{ marginBottom: "20px" }} />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        While the World Series may have wrapped, baseball never truly stops. The Arizona Fall League has been in full swing for almost a month now, featuring a spattering of prospects that the 30 organizations want to get some more playing time for before next year. Every player has been sent down to Phoenix for some extra run for a specific reason, whether they spent a significant portion of the season on the injured list, were just drafted and needed a break after the college season, or are vying for a 40 man roster spot before the upcoming Rule 5 draft. This makes for an interesting combination of players to analyze – ESPECIALLY since these stadiums have statcast equipment installed with data open to the public. For some of these players, this is the first time we've seen public data to dive into, providing a treasure trove of new info. That being said, the numbers on the screen can only take you so far without the context of actually watching the players producing it in action. So, I've flown to Arizona for a week of scouting with some specific names in mind to keep an eye on. Let's go over some of those names and go over what exactly I'm watching for and why.
        <br /><br />
      </Typography>
        <div style={{ textAlign: "center", margin: "20px 0", maxWidth: "100%" }}>
          <img src={require('../images/AFLThumb1.jpeg')} alt="loading..." style={{ maxWidth: "90%", border: "#293241 solid 2px" }} />
      </div>
      <Typography variant="h4" style={{ color: teamColors["GDD"][0], fontWeight: "bold", textShadow: "-2px -2px 0 " + teamColors["GDD"][1] + ", 2px -2px 0 " + teamColors["GDD"][1] + ", -2px 2px 0 " + teamColors["GDD"][1] + ", 2px 2px 0 " + teamColors["GDD"][1] + "",
          }}>
        Glendale Desert Dogs (Atlanta Braves, Chicago White Sox, Los Angeles Dodgers, St. Louis Cardinals, Toronto Blue Jays)
      </Typography>
      <br />

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#27251F", textShadow: "-1px -1px 0 " + teamColors["CHW"][1] + ", 1px -1px 0 " + teamColors["CHW"][1] + ", -1px 1px 0 " + teamColors["CHW"][1] + ", 1px 1px 0 " + teamColors["CHW"][1] + "" }}>Hagen Smith</span>, SP (CWS No. 4, MLB No. 88)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Smith was the 5th overall pick in the 2024 draft and looks to be on the way to joining the White Sox rotation at some point in 2026. He's got a great fastball-slider combo that tunnel very well with each other, forcing hitters to guess what's coming and look very silly if they're wrong. The main thing I'll be watching is how much he works in his changeup, as his arsenal could use some variety beyond his main two offerings.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#27251F", textShadow: "-1px -1px 0 " + teamColors["CHW"][1] + ", 1px -1px 0 " + teamColors["CHW"][1] + ", -1px 1px 0 " + teamColors["CHW"][1] + ", 1px 1px 0 " + teamColors["CHW"][1] + "" }}>Braden Montgomery</span> (CWS No. 1, MLB No. 35)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Acquired by Chicago in the Garrett Crochet trade, Montgomery is bursting with potential. He's a switch hitter with great pop from both sides of the plate, solid speed, a great arm, and an impressive plate approach. I'll be interested to see if he can handle center field or if need to be pushed to a corner outfield spot, as well as where his strikeout rate lands against higher level pitching.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: teamColors["ATL"][1], textShadow: "-1px -1px 0 " + teamColors["ATL"][1] + ", 1px -1px 0 " + teamColors["ATL"][0] + ", -1px 1px 0 " + teamColors["ATL"][0] + ", 1px 1px 0 " + teamColors["ATL"][0] + "" }}>Nacho Alvarez Jr.</span> (ATL)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Alvarez has already gotten some time in the bigs – he's a decent all around prospect with a seemingly high floor. Good contact, good approach, solid fielding ability, but no real standout tool. He's performing very well in Arizona so far – I'll be watching to see if he can reach a new level and start hitting the ball hard with more consistency.
        <br /><br />
      </Typography>

      <Typography variant="h4" style={{ color: teamColors["PEJ"][0], fontWeight: "bold", textShadow: "-2px -2px 0 " + teamColors["PEJ"][1] + ", 2px -2px 0 " + teamColors["PEJ"][1] + ", -2px 2px 0 " + teamColors["PEJ"][1] + ", 2px 2px 0 " + teamColors["PEJ"][1] + "",}}>
        Peoria Javelinas (Baltimore Orioles, Cincinnati Reds, Minnesota Twins, San Diego Padres, Seattle Mariners)
      </Typography>
      <br />

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#C6011F", textShadow: "-1px -1px 0 " + teamColors["CIN"][1] + ", 1px -1px 0 " + teamColors["CIN"][1] + ", -1px 1px 0 " + teamColors["CIN"][1] + ", 1px 1px 0 " + teamColors["CIN"][1] + "" }}>Alfredo Duno</span>, C (CIN No. 2, MLB No. 48)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        As the Florida State League PS Score leader for 2025, Alfredo Duno has been a player I've had my eye on for a while. At age 19, he terrorized Class A pitching, walking more than he struck out while barreling the ball and producing high exit velocities more frequently than pretty much anyone else at the level. He's a special player and could be a future MVP type talent, especially if he remains at catcher. I'll be watching to see how he fairs against higher level pitching and to see how he fields the catcher position.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#C6011F", textShadow: "-1px -1px 0 " + teamColors["CIN"][1] + ", 1px -1px 0 " + teamColors["CIN"][1] + ", -1px 1px 0 " + teamColors["CIN"][1] + ", 1px 1px 0 " + teamColors["CIN"][1] + "" }}>Rhett Lowder</span>, SP (CIN No. 5, MLB No. 80)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Lowder is a pretty known commodity at this point, already having shown some success at the big league level. He spent most of 2025 recovering from injuries and is now back in action in Arizona. He often lives in the zone with his fastballs which don't generate a lot of whiffs – I'll be interested to see if he can start really commanding the edges of the zone and force more hitters to chase.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#DF4601", textShadow: "-1px -1px 0 " + teamColors["BAL"][1] + ", 1px -1px 0 " + teamColors["BAL"][1] + ", -1px 1px 0 " + teamColors["BAL"][1] + ", 1px 1px 0 " + teamColors["BAL"][1] + "" }}>Enrique Bradfield Jr.</span>, CF (BAL No. 4)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Bradfield was Baltimore's 1st rounder from 2023 – he's a true center fielder with extreme speed and fielding ability. If he gets on 1st, 2nd is as good as his. He spent a good portion of '25 out with various hamstring strains, so I'll be watching to make sure the speed is all the way back and looking to see if he can consistently get himself on base.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#DF4601", textShadow: "-1px -1px 0 " + teamColors["BAL"][1] + ", 1px -1px 0 " + teamColors["BAL"][1] + ", -1px 1px 0 " + teamColors["BAL"][1] + ", 1px 1px 0 " + teamColors["BAL"][1] + "" }}>Luis De León</span>, SP (BAL No. 21)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Luis De León, an international signing that has been cooking in Baltimore's system since 2022, is a name we could all be hearing a lot more soon. His stuff is wicked, generating 11 K/9 across 3 levels in 2025, but his inconsistent mechanics and release points have led to a lot of command issues. He could still end up being an elite reliever if he can't find consistency, but Baltimore could certainly use a strikeout heavy lefty in their rotation. I'll be watching to see how makes in-game adjustments when one or more of his offerings can't find the zone and how he fairs across multiple innings.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#C6011F", textShadow: "-1px -1px 0 " + teamColors["CIN"][1] + ", 1px -1px 0 " + teamColors["CIN"][1] + ", -1px 1px 0 " + teamColors["CIN"][1] + ", 1px 1px 0 " + teamColors["CIN"][1] + "" }}>Cam Collier</span>, 3B (CIN No. 6)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Collier is a young third baseman with a ton of raw power and a strong arm. The main reason I have him on the list is because of the impressive bat speed numbers he's been showing off in Arizona, sitting around 73 mph on his average swing. On top of that, he's also shown an ability to consistently get on base by walking. Despite his power potential, he didn't leave the yard much in '25 at AA, perhaps due to needing some time to recover from thumb surgery earlier in the year. He's already hit a ball 115.3 mph in AFL play – I'll be looking to see if he can tap into this raw power more consistently.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#2F241D", textShadow: "-1px -1px 0 " + teamColors["SDP"][1] + ", 1px -1px 0 " + teamColors["SDP"][1] + ", -1px 1px 0 " + teamColors["SDP"][1] + ", 1px 1px 0 " + teamColors["SDP"][1] + "" }}>Tucker Musgrove</span>, SP (SDP NR)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Despite being drafted in 2023, Musgrove did not debut until earlier this year due to needing to recover from Tommy John. Now that he's back on the mound, it's clear Musgrove has some special stuff. He's able to sit at 98 with his 4-seam and sinker and throws a slider with solid movement, although he seems to be having some trouble keeping the shape consistent. He has graded out as one of the best pitchers by psStuff+ in AFL so far – I'll be looking to see what exactly the Padres have here given his lack of professional track record. He could be a solid big league reliever at some point in the next couple years.
        <br /><br />
      </Typography>

      <Typography variant="h4" style={{ color: teamColors["MSS"][0], fontWeight: "bold", textShadow: "-2px -2px 0 " + teamColors["MSS"][1] + ", 2px -2px 0 " + teamColors["MSS"][1] + ", -2px 2px 0 " + teamColors["MSS"][1] + ", 2px 2px 0 " + teamColors["MSS"][1] + "" }}>
        Mesa Solar Sox (Athletics, Chicago Cubs, Miami Marlins, New York Yankees, Tampa Bay Rays)
      </Typography>
      <br />

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#00A3E0", textShadow: "-1px -1px 0 " + teamColors["MIA"][1] + ", 1px -1px 0 " + teamColors["MIA"][1] + ", -1px 1px 0 " + teamColors["MIA"][1] + ", 1px 1px 0 " + teamColors["MIA"][1] + "" }}>PJ Morlando</span>, OF (MIA No. 15)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Morlando has a lot of potential as a well rounded outfielder with great raw power and flashes of speed, but he just hasn't been able to put it together in the pros so far. Scouts are high on him as someone who could be a future top 100 prospect, but he has a long way to go. I'll be watching to see what kind of adjustments he's making to his approach in Arizona, as well as whether or not his speed can be a factor in-game.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#00A3E0", textShadow: "-1px -1px 0 " + teamColors["MIA"][1] + ", 1px -1px 0 " + teamColors["MIA"][1] + ", -1px 1px 0 " + teamColors["MIA"][1] + ", 1px 1px 0 " + teamColors["MIA"][1] + "" }}>Starlyn Caba</span>, SS (MIA No. 5)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Caba, flipped to Miami from Philly in the Jesus Luzardo trade, is a speedy shortstop who hits for contact and creates chaos on the basepaths. While he hit for a great average in rookie ball, his offensive production has significantly slowed down at Class A ball. Still, he's only 19 and has a lot of room to grow and refine his approach. Without much power to speak of, I'll be watching to see if he can be a consistent producer at the plate by maintaining a high contact rate and putting the ball in play.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#0E3386", textShadow: "-1px -1px 0 " + teamColors["CHC"][1] + ", 1px -1px 0 " + teamColors["CHC"][1] + ", -1px 1px 0 " + teamColors["CHC"][1] + ", 1px 1px 0 " + teamColors["CHC"][1] + "" }}>Owen Ayers</span>, C (CHC NR)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Ayers has found himself on the prospect radar with a very impressive showing in Arizona thus far. He's doing everything well at the plate – consistently hitting the ball hard, walking twice as much as he strikes out, swinging a fast bat, and showing good pop from both sides. He's a bit older so it makes sense that he's punishing some of the younger pitchers he's seeing in Arizona, but he's really making a name for himself with his current production. I'll be looking to see how he fares as a catcher – if he can field the position well and continue to be the solid all around hitter he's looked like, he should rise the ranks quickly in '26 for Chicago.
        <br /><br />
      </Typography>

      <Typography variant="h4" style={{ color: teamColors["SCO"][0], fontWeight: "bold", textShadow: "-2px -2px 0 " + teamColors["SCO"][1] + ", 2px -2px 0 " + teamColors["SCO"][1] + ", -2px 2px 0 " + teamColors["SCO"][1] + ", 2px 2px 0 " + teamColors["SCO"][1] + "" }}>
        Scottsdale Scorpions (Detroit Tigers, Houston Astros, New York Mets, San Francisco Giants, Washington Nationals)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        The Scottsdale Scorpions are STACKED, to say the least. It's no surprise they're running an 11-6 record as I'm writing this – this roster is brimming with talent that we're likely to see in MLB sooner rather than later.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#0C2340", textShadow: "-1px -1px 0 " + teamColors["DET"][1] + ", 1px -1px 0 " + teamColors["DET"][1] + ", -1px 1px 0 " + teamColors["DET"][1] + ", 1px 1px 0 " + teamColors["DET"][1] + "" }}>Kevin McGonigle</span>, SS (DET No. 1, MLB No. 2)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        The most obvious name on this list, and likely one everyone in attendance will be focusing on, is MLB Pipeline's number 2 prospect Kevin McGonigle. McGonigle missed time in both 2024 and 2025 with various injuries, but when he did play, he set MiLB on fire. He's a five tool shortstop with enough contact, discipline, fielding skill, and speed to crack the big leagues and play every day for the Tigers as soon as next year. Not much I can add here that hasn't already been said – this guy's a stud and Detroit clearly wants to see how soon they can bring him up. I'm expected to get wowed watching him lead off for the Scorpions.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: teamColors["HOU"][0], textShadow: "-1px -1px 0 " + teamColors["HOU"][1] + ", 1px -1px 0 " + teamColors["HOU"][1] + ", -1px 1px 0 " + teamColors["HOU"][1] + ", 1px 1px 0 " + teamColors["HOU"][1] + "" }}>Walker Janek</span>, C (HOU No. 4)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Janek was Houston's 1st rounder in 2024, picked up for his defensive abilities behind the plate. His plate discipline is concerning, but he has a good amount of pop and a surprising amount of speed for a catcher. The main thing I'll be watching is his plate approach and seeing what adjustments he can make to get on base more often. If he does, he'll make for an intriguing backstop for Houston.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#0C2340", textShadow: "-1px -1px 0 " + teamColors["DET"][1] + ", 1px -1px 0 " + teamColors["DET"][1] + ", -1px 1px 0 " + teamColors["DET"][1] + ", 1px 1px 0 " + teamColors["DET"][1] + "" }}>Max Anderson</span>, 3B (DET No. 9)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Anderson was Detroit's 2nd rounder in 2023, a college bat with an impressive ability to get on base through spraying line drives around the field. In the fall league, he'll look to find a place to settle defensively, likely 3rd base. He's been a standout so far in AFL, consistently barreling the ball. I'll be watching whether or not he can continue to get on base with his free swinging approach.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#AB0003", textShadow: "-1px -1px 0 " + teamColors["WSN"][1] + ", 1px -1px 0 " + teamColors["WSN"][1] + ", -1px 1px 0 " + teamColors["WSN"][1] + ", 1px 1px 0 " + teamColors["WSN"][1] + "" }}>Seaver King</span>, SS (WSH No. 7)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        The 10th pick in the 2024 draft has looked a little underwhelming so far in his young professional career considering the draft stock Washington was willing to spend on him. Still, he's got great speed and fields a solid shortstop. There have been questions about his bat path and swing in general as well as some struggles with breaking pitches, but if he can figure those out he should be able to rise up prospects ranks.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#AB0003", textShadow: "-1px -1px 0 " + teamColors["WSN"][1] + ", 1px -1px 0 " + teamColors["WSN"][1] + ", -1px 1px 0 " + teamColors["WSN"][1] + ", 1px 1px 0 " + teamColors["WSN"][1] + "" }}>Ethan Petry</span> (WSH No. 8)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Petry was the Nationals' 2nd round pick in 2025. While not a highly touted prospect by most outlets, he's caught my eye with his SUPREME bat speed. He's sitting at an average speed of nearly 75 mph, comparable to elite power hitters Cal Raleigh and Pete Alonso. If he can consistently make contact and continue to get on base, he could be the Nats 1st baseman of the future.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#AB0003", textShadow: "-1px -1px 0 " + teamColors["WSN"][1] + ", 1px -1px 0 " + teamColors["WSN"][1] + ", -1px 1px 0 " + teamColors["WSN"][1] + ", 1px 1px 0 " + teamColors["WSN"][1] + "" }}>Jake Bennett</span> (WSH No. 10)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Bennett missed the 2024 season while recovering from Tommy John surgery and came back in 2025 looking solid. He's a lefty with solid stuff and stellar command. I'll be watching to see where his fastball is sitting and to confirm that he's someone Washington will be looking to add to their 40 man to protect from the Rule 5 draft.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#000000ff", textShadow: "-1px -1px 0 " + teamColors["SFG"][1] + ", 1px -1px 0 " + teamColors["SFG"][1] + ", -1px 1px 0 " + teamColors["SFG"][1] + ", 1px 1px 0 " + teamColors["SFG"][1] + "" }}>Parks Harber</span>, 1B/3B (SFG NR)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Harber was acquired from the Yankees as a piece in the Camilo Doval trade. While not ranked in San Francisco's top 30, he's shown an impressive ability for hard contact and getting on base in the lower minors. He's already hit a ball 114.3 mph in Fall League play and is currently one of the hottest hitters in Arizona. If he keeps up this level of play, he'll be hard for the Giants to ignore. I'll be watching to see if there's any obvious holes in his game keeping him from being ranked.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#002D62", textShadow: "-1px -1px 0 " + teamColors["HOU"][1] + ", 1px -1px 0 " + teamColors["HOU"][1] + ", -1px 1px 0 " + teamColors["HOU"][1] + ", 1px 1px 0 " + teamColors["HOU"][1] + "" }}>Hudson Leach</span>, RP (HOU NR)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Leach was picked up by Houston in 2023 as a UDFA and has been making a name for himself so far in the Fall League. He's striking out over the half the batters he's facing, touching 98 on his fastball and throwing a disgusting curveball which may be the best breaking pitch of anyone in Arizona. I'll be looking to see if he can stay in the zone and continue to dominate – he'll find his way to Houston's bullpen next year if he does.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: teamColors["DET"][0], textShadow: "-1px -1px 0 " + teamColors["DET"][1] + ", 1px -1px 0 " + teamColors["DET"][1] + ", -1px 1px 0 " + teamColors["DET"][1] + ", 1px 1px 0 " + teamColors["DET"][1] + "" }}>Kenny Serwa</span>, SP (DET NR)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Serwa throws a knuckleball. Need I say more?
        <br /><br />
      </Typography>

      <Typography variant="h4" style={{ color: teamColors["SRR"][0], fontWeight: "bold", textShadow: "-2px -2px 0 " + teamColors["SRR"][1] + ", 2px -2px 0 " + teamColors["SRR"][1] + ", -2px 2px 0 " + teamColors["SRR"][1] + ", 2px 2px 0 " + teamColors["SRR"][1] + "" }}>
        Salt River Rafters (Arizona Diamondbacks, Boston Red Sox, Colorado Rockies, Los Angeles Angels, Pittsburgh Pirates)
      </Typography>
      <br />

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#FDB827", textShadow: "-1px -1px 0 " + teamColors["PIT"][1] + ", 1px -1px 0 " + teamColors["PIT"][1] + ", -1px 1px 0 " + teamColors["PIT"][1] + ", 1px 1px 0 " + teamColors["PIT"][1] + "" }}>Esmerlyn Valdez</span>, 1B/OF (PIT No. 15)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Valdez is destroying the pitching he's seeing in Arizona so far, hitting 8 homers in his first 9 games of the year while limiting strikeouts and walking a fair amount as well. He's a bat first prospect with little defensive ability or speed to speak of, but if his power can continue to play against higher level pitching he'll be a must have in Pittsburgh's lineup. I'll be watching to see how he's handling different pitch types and trying to get a gauge of whether or not his AFL success is coming from punishing poor pitching.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#333366", textShadow: "-1px -1px 0 " + teamColors["COL"][1] + ", 1px -1px 0 " + teamColors["COL"][1] + ", -1px 1px 0 " + teamColors["COL"][1] + ", 1px 1px 0 " + teamColors["COL"][1] + "" }}>Charlie Condon</span>, 1B/OF (COL No. 2, MLB No. 61)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        The 3rd overall pick from the 2024 draft has looked good but not great so far in his professional career. At 6'6", he has absurd raw power potential but hasn't always been tapping into it thus far. While he's running good numbers so far in Arizona, it's coming without a lot of long balls and he seems to be having some issues consistently elevating the ball. His plate approach is slowly improving over time and he's avoiding whiffs – I'll be interested to see if he can combine his more disciplined approach with his power potential and what his max exit velocity will top out at.
        <br /><br />
      </Typography>

      <Typography variant="h4" style={{ color: teamColors["SUR"][0], fontWeight: "bold", textShadow: "-2px -2px 0 " + teamColors["SUR"][1] + ", 2px -2px 0 " + teamColors["SUR"][1] + ", -2px 2px 0 " + teamColors["SUR"][1] + ", 2px 2px 0 " + teamColors["SUR"][1] + "" }}>
        Surprise Saguaros (Cleveland Guardians, Kansas City Royals, Milwaukee Brewers, Philadelphia Phillies, Texas Rangers)
      </Typography>
      <br />

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: teamColors["TEX"][1], textShadow: "-1px -1px 0 " + teamColors["TEX"][0] + ", 1px -1px 0 " + teamColors["TEX"][0] + ", -1px 1px 0 " + teamColors["TEX"][0] + ", 1px 1px 0 " + teamColors["TEX"][0] + "" }}>Sebastian Walcott</span>, SS (TEX No. 1, MLB No. 6)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Walcott is a 19 year old international signee with ABSURD power potential. He's currently shut down with arm fatigue, but getting some more data on him would be a treat to get a better idea of his top end power (which could continue to grow). If he gets back into games, I'll be watching to see how he handles shortstop or if he'll need to make a move to a corner outfield spot.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: teamColors["CLE"][0], textShadow: "-1px -1px 0 " + teamColors["CLE"][1] + ", 1px -1px 0 " + teamColors["CLE"][1] + ", -1px 1px 0 " + teamColors["CLE"][1] + ", 1px 1px 0 " + teamColors["CLE"][1] + "" }}>Daniel Espino</span>, RP (CLE No. 29)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Espino is back in action after missing the 2023 and 2024 seasons with injuries. Before that, he was looking to be a front end of the rotation power pitching option for the Guardians. After 2 years off, his status and role is to be determined to say the least. He's got a great fastball that can reach triple digits and is still looking to refine the rest of his arsenal after his break from pitching. I'll be watching to see whether or not he can go multiple innings and how many different offerings he feels comfortable mixing in.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: teamColors["CLE"][0], textShadow: "-1px -1px 0 " + teamColors["CLE"][1] + ", 1px -1px 0 " + teamColors["CLE"][1] + ", -1px 1px 0 " + teamColors["CLE"][1] + ", 1px 1px 0 " + teamColors["CLE"][1] + "" }}>Joe Lampe</span>, CF (CLE NR)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        While Lampe is not ranked in Cleveland's top 30 due to his lack of true hitting ability, he's caught my eye by putting together some of the best numbers of his career in the Fall League so far. He profiles as a 4th outfielder with great speed and solid fielding ability, but if he can get on base consistently he could end up with an expanded role in Cleveland. I'll be watching his plate approach and seeing what he's doing differently in Arizona to reach his current level of success.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)", fontWeight: "bold" }}>
        <span style={{ color: "#E81828", textShadow: "-1px -1px 0 " + teamColors["PHI"][1] + ", 1px -1px 0 " + teamColors["PHI"][1] + ", -1px 1px 0 " + teamColors["PHI"][1] + ", 1px 1px 0 " + teamColors["PHI"][1] + "" }}>Dante Nori</span>, OF (PHI No. 6)
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Nori was Philadelphia's 1st round pick in the 2024 draft – he's a speedy outfielder with a great plate approach. In a short stint in AA, he seemed overmatched by the jump in pitching quality, but he gets on base enough and has the fielding ability to eventually be an everyday center fielder. I'll be watching to see how he handles higher level pitching and whether or not he can make up for his lack of power by walking and swiping bags.
        <br /><br />
      </Typography>
      <Divider />
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Those are the main guys I'll be keeping my eye on in Arizona, but I feel like some of the more interesting observations will come from the lesser-known players. If you're in the Phoenix area, I highly recommend checking out a game or two – it's a great way to see some of the game's best young talent up close. I'll be posting updates and observations on my Twitter while I'm there, so be sure to follow along there as well. Thanks for reading!
      </Typography>
      <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          mt: 8, 
          p: 3, 
          bgcolor: 'grey.50', 
          borderRadius: 2,
        }}>
          <Avatar sx={{ mr: 2, width: 56, height: 56, bgcolor: 'primary.main' }}>DH</Avatar>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>Duke Hill</Typography>
            <Typography variant="body2" color="text.secondary">
              Creator and Editor in Chief of Prospect Savant
            </Typography>
          </Box>
        </Box>
    </div>
  );
}